export default __webpack_public_path__ + "static/media/arrow-back-green.2d958e02.svg";